// Copyright 2016 Sorama B.V.

import { autoinject, singleton } from "aurelia-framework";
import { SoundCameraModels, WebcamConfiguration, WebcamMountConfiguration } from "datatypes/SoramaWebApi";
import { buildQueryString } from "extensions/UriExtensions";
import { Api } from "libraries/WebApi/Api";
import { IWebRequestHandler } from "libraries/WebRequestHandler/IWebRequestHandler";
import { Repository } from "repositories/Repository";

@singleton()
@autoinject
export class HardwareInformationRepository extends Repository {
    private webRequestHandler: IWebRequestHandler;

    constructor(webRequestHandler: IWebRequestHandler) {
        super();
        this.webRequestHandler = webRequestHandler;
    }

    //#region Get Requests
    public getWebcams(
        soundCameraModels?: SoundCameraModels,
        productId?: number,
        vendorId?: number
    ): Promise<WebcamConfiguration[]> {
        const queryString = buildQueryString({
            soundCameraModels: soundCameraModels,
            productId: productId,
            vendorId: vendorId,
        });

        return this.webRequestHandler
            .createGetRequest<WebcamConfiguration[]>(Api.hardwareInformation + "/Webcams" + queryString)
            .send()
            .then((x) => x.content)
            .catch((e) => this.onError(e));
    }

    public getWebcamMounts(
        soundCameraModels?: SoundCameraModels,
        productId?: number,
        vendorId?: number
    ): Promise<WebcamMountConfiguration[]> {
        const queryString = buildQueryString({
            soundCameraModels: soundCameraModels,
            productId: productId,
            vendorId: vendorId,
        });

        return this.webRequestHandler
            .createGetRequest<WebcamMountConfiguration[]>(Api.hardwareInformation + "/WebcamMounts" + queryString)
            .send()
            .then((x) => x.content)
            .catch((e) => this.onError(e));
    }

    //#endregion
}
